const OrderOverviewBillingData = (props) => {
  if (!props) {
    return null;
  }

  const {
    genders,
    countries,
    customerData,
    hasModuleScheduler,
    hasBillingInfoChangeLink,
    textsMapping,
    goToStep,
  } = props;

  const renderCompanyData = () => {
    let selectedCountry = countries.find(
      (obj) =>
        obj.value ===
        customerData.companyInvoiceDetails.selectedCompany.address.country
    );

    return (
      <dl>
        <dt>{textsMapping.orderOverviewBillingDataName}</dt>
        <dd>{customerData.companyInvoiceDetails.selectedCompany.name}</dd>

        {customerData.companyInvoiceDetails.selectedCompany
          .chamberOfCommerce && (
          <>
            <dt>{textsMapping.orderOverviewBillingDataChamberOfCommerce}</dt>
            <dd>
              {
                customerData.companyInvoiceDetails.selectedCompany
                  .chamberOfCommerce
              }
            </dd>
          </>
        )}

        <dt>{textsMapping.orderOverviewBillingDataCompanyAddress}</dt>
        <dd>
          {customerData.companyInvoiceDetails.selectedCompany.address.street}{" "}
          {
            customerData.companyInvoiceDetails.selectedCompany.address
              .houseNumber
          }{" "}
          {
            customerData.companyInvoiceDetails.selectedCompany.address
              .houseNumberAddition
          }
          <br />
          {customerData.companyInvoiceDetails.selectedCompany.address.zip},{" "}
          {customerData.companyInvoiceDetails.selectedCompany.address.city}
          <br />
          {!customerData.companyInvoiceDetails.selectedCompany.address
            .defaultCountry && selectedCountry !== undefined
            ? selectedCountry.name
            : null}
        </dd>

        {customerData.companyInvoiceDetails.companyOrderReference && (
          <>
            <dt>
              {textsMapping.orderOverviewBillingDataCompanyOrderReference}
            </dt>
            <dd>{customerData.companyInvoiceDetails.companyOrderReference}</dd>
          </>
        )}

        <>
          <dt>{textsMapping.orderOverviewBillingDataEmail}</dt>
          <dd>{customerData.companyInvoiceDetails.companyInvoiceEmail}</dd>
        </>
      </dl>
    );
  };

  const renderPersonalData = () => {
    const selectedGender = genders.find(
      (obj) => obj.value === customerData.personalDetails.salutation
    );

    return (
      <dl>
        <dt>{textsMapping.orderOverviewBillingDataName}</dt>
        <dd>
          {selectedGender !== undefined ? selectedGender.name : null}{" "}
          {customerData.personalDetails.initials}{" "}
          {customerData.personalDetails.lastName}
          <span className="order-overview__billing-data-equal-remark">
            {textsMapping.orderOverviewBillingDataEqualText}
          </span>
        </dd>
      </dl>
    );
  };

  return (
    <section className="checkout-section order-overview__billing-data">
      <div className="checkout-section__header">
        <div className="checkout-section__header-text">
          <h3 className="checkout-section__title">
            {textsMapping.orderOverviewBillingDataTitle}
          </h3>
          <p>{textsMapping.orderOverviewBillingDataText}</p>
        </div>
        {hasBillingInfoChangeLink && (
          <button
            type="button"
            onClick={() => goToStep("jump", hasModuleScheduler ? 1 : 0)}
            className="checkout-section__edit-link nev-icon nev-icon-pencil"
          >
            <span className="checkout-section__edit-link-text">
              {textsMapping.editLinkText}
            </span>
          </button>
        )}
      </div>
      {customerData.companyInvoiceDetails.selectedCompany
        ? renderCompanyData()
        : renderPersonalData()}
    </section>
  );
};

export default OrderOverviewBillingData;
